















import VueOptions from '@utils/VueOptions'

settings =
  name: 'VenueRemoteForm'

  vue:
    props: ['wizard', 'venue']

    data: ->
      form: @venue

export default VueOptions.vue settings
